interface CouponTicketTypeDiscountParams {
  /** One ticket's amount, after its bulk tier. */
  amount: number;
  coupon: { amountOff?: number; percentOff?: number; ticketTypes?: string[] } | null | undefined;
  ticketTypeId: string;
  quantity: number;
}

export interface CouponTicketTypeDiscount {
  couponDiscountAmountPerTicket: number;
  couponDiscountAmount: number;
}

const NO_DISCOUNT: CouponTicketTypeDiscount = {
  couponDiscountAmountPerTicket: 0,
  couponDiscountAmount: 0,
};

// Rounded per ticket then multiplied by quantity: the API charges each ticket
// in whole minor units, and rounding the line once drifts by a cent.
export const getCouponTicketTypeDiscount = ({
  amount,
  coupon,
  ticketTypeId,
  quantity,
}: CouponTicketTypeDiscountParams): CouponTicketTypeDiscount => {
  const chargeAmount = Number(amount);

  if (!coupon) {
    return NO_DISCOUNT;
  }

  const appliesToThisTicket = (coupon.ticketTypes ?? []).some(
    couponTicketTypeId => couponTicketTypeId === ticketTypeId,
  );

  if (!appliesToThisTicket) {
    return NO_DISCOUNT;
  }

  let discountPerTicket: number | null = null;

  if (coupon.amountOff) {
    discountPerTicket = coupon.amountOff;
  }

  if (coupon.percentOff) {
    discountPerTicket = chargeAmount - chargeAmount * (1 - coupon.percentOff / 100);
  }

  // Math.round is what the API's accounting.toFixed does; accounting-js adds
  // 1e-8 first, which rounds a float like 10.4999999 up and misses by a cent.
  const couponDiscountAmountPerTicket = Math.round(Math.min(discountPerTicket || 0, chargeAmount));

  return {
    couponDiscountAmountPerTicket,
    couponDiscountAmount: couponDiscountAmountPerTicket * quantity,
  };
};
